import axios from "axios";
import settings from "utils/settings";

const apiUrl = `${settings.apiUrl}api/`;

const controllerUrl = `${apiUrl}triggered-action`;

export const requestDelete = (id) =>
  axios.delete(`${controllerUrl}/${id}`);

export const requestList = criteria =>
  axios.post(`${controllerUrl}/list`, {
    criteria
  });



// WEBPACK FOOTER //
// ./src/actions/bike-trigger-history/requests.js